import React, { ReactNode } from 'react';

type Props = {
  white?: boolean;
  children: ReactNode;
};

function TableHead({ white, children }: Props) {
  const classes = [];

  if (white) {
    classes.push('bg-white');
  } else {
    classes.push('bg-gray-50');
  }

  return <thead className={classes.join(' ')}>{children}</thead>;
}

export default TableHead;
